import {
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_FAILURE,
  GET_COMMENTS_REQUESTED,
  ADD_COMMENT_SUCCESS,
  UPDATE_COMMENT_SUCCESS,
} from './comments.constants'
import API from './comments.api'
import { AppThunk } from '../../../root.reducer'

export const getComments = (contactId: $TSFIXME, evalFormId: $TSFIXME): AppThunk => {
  return async dispatch => {
    dispatch(getCommentsRequested())
    try {
      const comment = await API.getComments(contactId, evalFormId)

      dispatch(getCommentsSuccess(comment))
    } catch (error) {
      dispatch(getCommentsFailure(error))
    }
  }
}

export const getCommentsRequested = () => ({
  type: GET_COMMENTS_REQUESTED,
}) as const

export const getCommentsSuccess = (data: $TSFIXME) => ({
  data,
  type: GET_COMMENTS_SUCCESS,
}) as const

export const getCommentsFailure = (error: $TSFIXME) => ({
  error,
  type: GET_COMMENTS_FAILURE,
}) as const

export const addCommentSuccess = (data: $TSFIXME) => ({
  data,
  type: ADD_COMMENT_SUCCESS,
}) as const

export const updateCommentSuccess = (data: $TSFIXME) => ({
  data,
  type: UPDATE_COMMENT_SUCCESS,
}) as const

export type CommentsAction = ReturnType<
  | typeof getCommentsRequested
  | typeof getCommentsSuccess
  | typeof getCommentsFailure
  | typeof addCommentSuccess
  | typeof updateCommentSuccess
>
